const geralRoutes = [
  {
    path: '/geral/copia-tabelas',
    name: 'geral.copiatabelas',
    component: () => import('../views/geral/CopiaBaseDados.vue'),
  },
  {
    path: '/geral/campos-personalizados',
    name: 'geral.campopersonalizado',
    component: () => import('../views/geral/CampoPersonalizado.vue'),
    props: true,
  },
  {
    path: '/geral/tours',
    name: 'geral.tours',
    component: () => import('../views/geral/Tours.vue'),
    props: true,
  },
];

export default geralRoutes;
